document.addEventListener('DOMContentLoaded', function() {
  const EVENT_DATE_LABEL = 'Event Wear Date:';
  const getTodayString = () => new Date().toISOString().split('T')[0];

  const enforceminDateOniOS = (input) => {
    const errorMsg = document.createElement('p');
    errorMsg.style.cssText = 'color: red; font-size: 12px; margin: 4px 0 0 0; display: none;';
    errorMsg.textContent = 'Please select a date from today onwards.';
    input.parentNode.insertBefore(errorMsg, input.nextSibling);

    input.addEventListener('change', function() {
      const selectedDate = this.value;
      const today = getTodayString();

      if (selectedDate && selectedDate < today) {
        this.value = '';

        this.min = today;

        errorMsg.style.display = 'block';

        setTimeout(() => {
          errorMsg.style.display = 'none';
        }, 3000);
      } else {
        errorMsg.style.display = 'none';
      }
    });
  };

  const convertEventDateInput = () => {
    const labels = document.querySelectorAll('.bcpo-label .bcpo-title');
    labels.forEach(label => {
      if (label.textContent.trim().toLowerCase() === EVENT_DATE_LABEL.trim().toLowerCase()) {
        const wrapper = label.closest('.selector-wrapper');
        if (wrapper) {
          const input = wrapper.querySelector('input[type="text"]');
          if (input && !input.dataset.converted) {
            input.dataset.converted = 'true';

            const today = getTodayString();
            input.setAttribute('min', today);

            input.type = 'date';

            input.style.webkitAppearance = 'none';
            input.style.display = 'block';
            input.style.width = '100%';
            input.style.boxSizing = 'border-box';
            input.style.minHeight = '44px';
            input.style.padding = '8px';

            input.setAttribute('min', today);

            enforceminDateOniOS(input);

            if (observer) {
              observer.disconnect();
            }
          }
        }
      }
    });
  };

  let observer;
  const startObserver = () => {
    const productInfoContainer = document.querySelector('.js-product.product-info');
    if (!productInfoContainer) return;

    observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          requestAnimationFrame(() => convertEventDateInput());
        }
      }
    });

    observer.observe(productInfoContainer, { childList: true, subtree: true });
  };

  const productInfoContainer = document.querySelector('.js-product.product-info');
  if (productInfoContainer) {
    const lazyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          convertEventDateInput();
          startObserver();
          lazyObserver.disconnect();
        }
      });
    }, { threshold: 0.1 });

    lazyObserver.observe(productInfoContainer);
  } else {
    convertEventDateInput();
    startObserver();
  }
});